module.exports = __webpack_public_path__ + "static/media/Square-logo.ec2a4cf0.svg";